import request from './request'

/**
 * 分页查询加盟商列表
 * @param {object} data - 查询参数
 * @param {string} [data.name] - 加盟商名称（模糊查询）
 * @param {number[]} [data.statuses] - 状态列表: 0-潜在, 1-意向, 2-签约审核中, 3-正式, 4-暂停, 5-终止
 * @param {number[]} [data.levels] - 等级列表: 0-普通, 1-银牌, 2-金牌, 3-钻石
 * @param {number} [data.ownerUserId] - 负责人ID
 * @param {string} [data.majorRegion] - 大区域
 * @param {string} [data.minorRegion] - 小区域
 * @param {string} [data.joinDateFrom] - 加盟开始日期
 * @param {string} [data.joinDateTo] - 加盟结束日期
 * @param {boolean} [data.expiringSoon] - 是否即将到期（30天内）
 * @param {boolean} [data.needVisit] - 是否有待回访
 * @param {boolean} [data.needPerformance] - 是否需要业绩数据
 * @param {number} [data.current] - 当前页码（从1开始）
 * @param {number} [data.size] - 每页大小
 */
export function getFranchiseePage(data) {
  return request.post('/franchisee/page', data)
}

/**
 * 获取加盟商详情
 * @param {number} id - 加盟商ID
 */
export function getFranchisee(id) {
  return request.get(`/franchisee/${id}`)
}

/**
 * 创建加盟商
 * @param {object} data - 创建加盟商请求
 * @param {string} data.name - 加盟商名称
 * @param {number} [data.status] - 状态: 0-潜在, 1-意向, 2-签约审核中, 3-正式, 4-暂停, 5-终止
 * @param {number} [data.level] - 等级: 0-普通, 1-银牌, 2-金牌, 3-钻石
 * @param {number} [data.ownerUserId] - 负责人ID
 * @param {number} [data.ownerDeptId] - 所属部门ID
 * @param {string} [data.majorRegion] - 大区域
 * @param {string} [data.minorRegion] - 小区域
 * @param {string} [data.address] - 详细地址
 * @param {string} [data.joinDate] - 加盟日期
 * @param {string} [data.expireDate] - 到期日期
 * @param {number} [data.deposit] - 保证金
 * @param {string} [data.remark] - 备注
 */
export function createFranchisee(data) {
  return request.post('/franchisee', data)
}

/**
 * 更新加盟商
 * @param {object} data - 更新加盟商请求
 * @param {number} data.id - 加盟商ID
 * @param {string} [data.name] - 加盟商名称
 * @param {number} [data.status] - 状态
 * @param {number} [data.level] - 等级
 * @param {number} [data.ownerUserId] - 负责人ID
 * @param {number} [data.ownerDeptId] - 所属部门ID
 * @param {string} [data.majorRegion] - 大区域
 * @param {string} [data.minorRegion] - 小区域
 * @param {string} [data.address] - 详细地址
 * @param {string} [data.joinDate] - 加盟日期
 * @param {string} [data.expireDate] - 到期日期
 * @param {number} [data.deposit] - 保证金
 * @param {string} [data.remark] - 备注
 */
export function updateFranchisee(data) {
  return request.put('/franchisee', data)
}

/**
 * 删除加盟商
 * @param {number} id - 加盟商ID
 */
export function deleteFranchisee(id) {
  return request.delete(`/franchisee/${id}`)
}

/**
 * 变更加盟商状态
 * @param {object} data - 状态变更请求
 * @param {number} data.id - 加盟商ID
 * @param {number} data.toStatus - 目标状态: 0-潜在, 1-意向, 2-签约审核中, 3-正式, 4-暂停, 5-终止
 * @param {string} [data.reason] - 变更原因
 */
export function changeFranchiseeStatus(data) {
  return request.post('/franchisee/changeStatus', data)
}

/**
 * 分页查询回访记录
 * @param {object} data - 查询参数
 * @param {number} [data.franchiseeId] - 加盟商ID
 * @param {number} [data.visitType] - 回访方式: 0-电话, 1-微信, 2-上门, 3-邮件, 4-其他
 * @param {number} [data.visitUserId] - 回访人ID
 * @param {string} [data.visitTimeFrom] - 回访开始时间
 * @param {string} [data.visitTimeTo] - 回访结束时间
 * @param {boolean} [data.pendingVisit] - 待回访
 * @param {number} [data.current] - 当前页码（从1开始）
 * @param {number} [data.size] - 每页大小
 */
export function getFranchiseeVisitPage(data) {
  return request.post('/franchisee/visit/page', data)
}

/**
 * 获取某加盟商的所有回访记录
 * @param {number} franchiseeId - 加盟商ID
 */
export function getFranchiseeVisitList(franchiseeId) {
  return request.get(`/franchisee/visit/listByFranchisee/${franchiseeId}`)
}

/**
 * 创建回访记录
 * @param {object} data - 创建回访记录请求
 * @param {number} data.franchiseeId - 加盟商ID
 * @param {number} data.visitType - 回访方式: 0-电话, 1-微信, 2-上门, 3-邮件, 4-其他
 * @param {string} data.content - 回访内容
 * @param {string} [data.visitTime] - 回访时间
 * @param {string} [data.nextVisitTime] - 下次回访时间
 * @param {string} [data.issues] - 问题/需求记录
 * @param {number} [data.visitUserId] - 回访人ID
 */
export function createFranchiseeVisit(data) {
  return request.post('/franchisee/visit', data)
}

/**
 * 更新回访记录
 * @param {object} data - 更新回访记录请求
 * @param {number} data.id - 主键ID
 * @param {number} [data.franchiseeId] - 加盟商ID
 * @param {number} [data.visitType] - 回访方式
 * @param {string} [data.content] - 回访内容
 * @param {string} [data.visitTime] - 回访时间
 * @param {string} [data.nextVisitTime] - 下次回访时间
 * @param {string} [data.issues] - 问题/需求记录
 */
export function updateFranchiseeVisit(data) {
  return request.put('/franchisee/visit', data)
}

/**
 * 删除回访记录
 * @param {number} id - 主键ID
 */
export function deleteFranchiseeVisit(id) {
  return request.delete(`/franchisee/visit/${id}`)
}

/**
 * 根据ID列表获取加盟商简要信息（下拉选择用）
 * @param {number[]} ids - 加盟商ID数组，传入空数组返回全部
 */
export function getFranchiseeListByIds(ids = []) {
  return request.post('/franchisee/listByIds', ids)
}

/**
 * 为加盟商批量授权产品
 * @param {number} franchiseeId - 加盟商ID
 * @param {number[]} productIds - 产品ID数组
 */
export function authorizeProducts(franchiseeId, productIds) {
  return request.post(`/franchisee/${franchiseeId}/authorizeProducts`, productIds)
}

/**
 * 取消加盟商的产品授权
 * @param {number} franchiseeId - 加盟商ID
 * @param {number[]} productIds - 产品ID数组
 */
export function revokeProducts(franchiseeId, productIds) {
  return request.post(`/franchisee/${franchiseeId}/revokeProducts`, productIds)
}

/**
 * 人工补录加盟商拉卡拉商户进件通过结果
 * @param {number|string} franchiseeId - 加盟商ID
 * @param {object} data - 补录数据
 * @param {string} data.merInnerNo - 拉卡拉内部商户号
 * @param {string} data.merchantNo - 银联商户号
 * @param {string} data.termNo - 拉卡拉终端号
 * @param {string} [data.contractId] - 进件ID或外部申请标识
 * @param {string} [data.orgCode] - 拉卡拉机构代码
 */
export function manualCompleteLakalaMerchantApply(franchiseeId, data) {
  return request.post(`/franchisee/${franchiseeId}/lakala/merchant-apply/manual-complete`, data)
}
